import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Jobs from "@/pages/Jobs";
import RadarSearch from "@/pages/RadarSearch";
import Saved from "@/pages/Saved";
import Applications from "@/pages/Applications";
import Profile from "@/pages/Profile";
import Settings from "@/pages/Settings";
import PostJob from "@/pages/PostJob";
import Applicants from "@/pages/Applicants";
import Legal from "@/pages/Legal";
import Dashboard from "@/pages/Dashboard";
import Talent from "@/pages/Talent";
import SavedCandidates from "@/pages/SavedCandidates";
import Clients from "@/pages/Clients";
import Submissions from "@/pages/Submissions";
import Upgrade from "@/pages/Upgrade";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import WorkHub from "@/pages/WorkHub";
import WorkLanding from "@/pages/WorkLanding";
import WorkJob from "@/pages/WorkJob";
import LiveInNetherlands from "@/pages/LiveInNetherlands";
import MobileTabBar from "@/components/MobileTabBar";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/radar" element={<RadarSearch />} />
            <Route path="/saved" element={<ProtectedRoute><Saved /></ProtectedRoute>} />
            <Route path="/applications" element={<ProtectedRoute><Applications /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/post-job" element={<ProtectedRoute employerOnly><PostJob /></ProtectedRoute>} />
            <Route path="/applicants" element={<ProtectedRoute employerOnly><Applicants /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute employerOnly><Dashboard /></ProtectedRoute>} />
            <Route path="/talent" element={<ProtectedRoute employerOnly><Talent /></ProtectedRoute>} />
            <Route path="/saved-candidates" element={<ProtectedRoute employerOnly><SavedCandidates /></ProtectedRoute>} />
            <Route path="/clients" element={<ProtectedRoute agencyOnly><Clients /></ProtectedRoute>} />
            <Route path="/submissions" element={<ProtectedRoute agencyOnly><Submissions /></ProtectedRoute>} />
            <Route path="/upgrade" element={<ProtectedRoute employerOnly><Upgrade /></ProtectedRoute>} />
            <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/work/jobs" element={<WorkHub />} />
            <Route path="/work/live-in-netherlands" element={<LiveInNetherlands />} />
            <Route path="/work/job/:id" element={<WorkJob />} />
            <Route path="/work/jobs/:slug" element={<WorkLanding />} />
          </Routes>
          <MobileTabBar />
          <Toaster position="top-right" richColors theme="dark" />
        </BrowserRouter>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
